import { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { InvoicesList } from '../invoice/InvoicesList';
import { PaymentsList } from './PaymentsList';
import {
  PayAccessControl,
  PayAuthorizations,
} from '../authorizations/PayAccessControl';
const ReservationsList = lazy(() => import('../reservations/ReservationsList'));
const ImportInvoicesScreen = lazy(
  () => import('../invoice/ImportInvoicesScreen')
);
const DebtInvoicesList = lazy(() => import('../invoice/DebtInvoiceList'));

const PaymentDetailScreen = lazy(() =>
  import('./PaymentDetailScreen').then((m) => ({
    default: m.PaymentDetailScreen,
  }))
);
const NewInvoiceScreen = lazy(() => import('../invoice/NewInvoiceScreen'));
const NewDebtInvoiceScreen = lazy(() =>
  import('../invoice/NewDebtInvoiceScreen').then((m) => ({
    default: m.NewDebtInvoiceScreen,
  }))
);
const InvoiceDetailScreen = lazy(() =>
  import('../invoice/InvoiceDetailScreen').then((m) => ({
    default: m.InvoiceDetailScreen,
  }))
);

export function PaymentsScreen(): JSX.Element {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path="/payments/:payment_id/detail">
        <PayAccessControl allowed={PayAuthorizations.viewPayments}>
          <PaymentDetailScreen />
        </PayAccessControl>
      </Route>
      <Route exact path="/invoices/debt-invoices/new">
        <PayAccessControl allowed={PayAuthorizations.createInvoice}>
          <NewDebtInvoiceScreen />
        </PayAccessControl>
      </Route>
      <Route exact path="/invoices/new">
        <PayAccessControl allowed={PayAuthorizations.createInvoice}>
          <NewInvoiceScreen />
        </PayAccessControl>
      </Route>
      <Route exact path="/invoices/:invoice_id/detail">
        <PayAccessControl allowed={PayAuthorizations.createInvoice}>
          <InvoiceDetailScreen />
        </PayAccessControl>
      </Route>
      <Route exact path={path}>
        <PayAccessControl allowed={PayAuthorizations.viewInvoices}>
          <InvoicesList context="invoice screen" />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/payments`}>
        <PayAccessControl allowed={PayAuthorizations.viewPayments}>
          <PaymentsList />
        </PayAccessControl>
      </Route>

      <Route exact path={`${path}/reservations`}>
        <PayAccessControl allowed={PayAuthorizations.viewPayments}>
          <ReservationsList />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/debt-invoices`}>
        <PayAccessControl allowed={PayAuthorizations.viewInvoices}>
          <DebtInvoicesList context="debt-invoice screen" />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/import`}>
        <PayAccessControl allowed={PayAuthorizations.manageInvoices}>
          <ImportInvoicesScreen />
        </PayAccessControl>
      </Route>
    </Switch>
  );
}
